import React from 'react';
import BookingCalendar from '../components/BookingCalendar';

const BookingPage = () => {
  return (
    <div className="booking-page">
      {/* Header */}
      <header className="booking-header">
        <div className="container">
          <a href="/">
            <img 
              src="https://customer-assets.emergentagent.com/job_3e8f6982-05b2-47e6-848f-33d6ad405bf8/artifacts/zdc1xlcb_capitalelite%20logo.png" 
              alt="Capital Elite Cleaning" 
              className="logo"
            />
          </a>
        </div>
      </header>

      <div className="booking-hero">
        <div className="container">
          <h1>Book Your Cleaning Service</h1>
          <p>Choose your preferred date and we'll take care of the rest</p>
        </div>
      </div>

      <BookingCalendar />

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2024 Capital Elite Cleaning. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default BookingPage;
